module.exports = __webpack_public_path__ + "assets/media/alexa-1.09ecbcf8.png";